import { UCSDKService } from "./ucf-sdk/index.js";

export const UCSDK = new UCSDKService();
